import React from 'react';
import { Heading } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import { learningDifficultyMetricsKeys } from '../../config/configListing';
import css from './ListingPage.module.css';
import { P } from '../PageBuilder/Primitives/P';

const SectionSkills = props => {
  const { intl, publicData } = props;
  const { learningDifficultyMetrics } = publicData || {};
  const hasLearningDifficultyMetrics =
    !!learningDifficultyMetrics && Object.keys(learningDifficultyMetrics).length > 0;
  const learningDifficultyTotalScore = (
    <span className={css.learningDifficultyTotalScore}> / 10</span>
  );
  return (
    <section id="skills" className={css.section}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.skills" />
      </Heading>
      <P className={css.sectionDescription}>
        <FormattedMessage id="ListingPage.skillsDescription" />
      </P>
      {hasLearningDifficultyMetrics ? (
        <div className={css.learningDifficultyMetrics}>
          {Object.keys(learningDifficultyMetricsKeys).map(key => {
            const learningDifficulty = learningDifficultyMetrics?.[key];
            const learningDifficultyScore = learningDifficulty?.score;
            const metrics = learningDifficulty?.metrics;
            if (learningDifficultyScore !== null && learningDifficultyScore !== undefined) {
              return (
                <div className={css.skillsBlocks}>
                  <div className={css.skillsBlock}>
                    <div className={css.skillsBlockContainer}>
                      <div className={css.skillsBlockContent}>
                        <h2>{key}</h2>
                        <h3>
                          <FormattedMessage
                            id="ListingPage.learningDifficultyScore"
                            values={{
                              score: learningDifficultyScore,
                              totalScore: ' / 10',
                            }}
                          />
                        </h3>
                        {/* <p>
                          Lorem ipsum dolor sit amet consectetur. Varius sit nunc vulputate
                          facilisis scelerisque non.
                        </p> */}
                      </div>
                      <div className={css.skillsBlockStats}>
                        {Object.keys(metrics).map(metricsKey => {
                          const metric = metrics?.[metricsKey];
                          const metricDescription =
                            learningDifficultyMetricsKeys?.[key]?.[metricsKey];
                          return (
                            <div className={css.learningDifficulty}>
                              <div className={css.learningDifficultyHeader}>
                                <div className={css.learningDifficultyTitle}>{metricsKey}</div>
                                <div className={css.learningDifficultyDescription}>
                                  {metricDescription}
                                </div>
                              </div>
                              <div className={css.learningDifficultyScore}>
                                <FormattedMessage
                                  id="ListingPage.learningDifficulty"
                                  values={{
                                    score: metric,
                                    totalScore: learningDifficultyTotalScore,
                                  }}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          })}
        </div>
      ) : null}
    </section>
  );
};

export default SectionSkills;
